import { FileOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation/initYup.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import {
  type ISortableWidgetData,
  WidgetCategory,
  WidgetMainType,
  WidgetType,
} from '../../../Widget.ts';
import { isContainerData } from '../../containers/IContainerWidget.ts';
import { CommonGraphicWidgetConfigSchema } from '../common/CommonGraphicWidgetConfigSchema.ts';
import { type IPageWidget } from './IPageWidget.ts';
import { PageWidgetComponent } from './PageWidgetComponent.tsx';
import { PageWidgetPreview } from './PageWidgetPreview.tsx';

const configValidator = CommonGraphicWidgetConfigSchema.shape({
  type: yup.string().exact(WidgetType.Page).required(),
})
  .required()
  .noUnknown() satisfies yup.ObjectSchema<IPageWidget>;

/**
 * Tipo del componente di visualizzazione di un divisore per il titolo.
 */
export const PageWidgetType: IWidgetType<IPageWidget> = {
  type: WidgetType.Page,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Divisione di Pagina',
  icon: <FileOutlined />,
  // Questo wiget non è al momento supportato in nessun tipo di configurazione
  supportedSectionTypes: [],
  hasValue: false,
  formComponent: PageWidgetComponent,
  configComponent: null,
  configValidator,
  previewComponent: PageWidgetPreview,
  translationSchema: tran.widget({
    helpText: tran.rte(),
  }),
  rules: [],
  isValidParent: (_, parent, parentData?: ISortableWidgetData) => {
    const isParentInRoot = !parent?.path?.length || parent?.path?.length === 0;
    // La pagina può essere posizionata _solo_ nella root, sopra a un qualuqnue widget _non_ contenitore
    // N.B. gli extra-droppable dei container sono di tipo 'other' quindi sono aree valide per la pagina
    // in questo modo è possibile spostare la pagina _tra_ i container (sempre se sono nella root)
    return !isContainerData(parentData) && isParentInRoot;
  },
};
